/**
 * @generated SignedSource<<548ca6b0137bf776361405367c2acf61>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetUseButtonFragment$data = {
  readonly dataset: {
    readonly slug: string;
  };
  readonly files: {
    readonly nodes: ReadonlyArray<{
      readonly size: number;
      readonly url: Url;
    }>;
  };
  readonly version: Semver;
  readonly " $fragmentType": "DatasetUseButtonFragment";
};
export type DatasetUseButtonFragment$key = {
  readonly " $data"?: DatasetUseButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetUseButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetUseButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DatasetVersionFileConnection",
      "kind": "LinkedField",
      "name": "files",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DatasetVersionFile",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "size",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dataset",
      "kind": "LinkedField",
      "name": "dataset",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};

(node as any).hash = "db806e645fb630b8b7666173a0d3b54c";

export default node;
